/** @format */

import { CITIES_EXTERNAL } from '@/@ducks/locations/constants';
import { getCityFormattedName } from '@/@ducks/locations/helpers';
import { TLocale } from '@/utils/gatsby/types';

const getCityRedirectCode = (city: string) => {
  switch (city) {
    case 'Venezia':
      return 'venezia';
    case 'Venice':
      return 'venice';
    case 'Como':
      return 'como-campus';
    case 'Trento':
      return 'trento';
    case 'Parma':
      return 'parma';
    case 'Siena':
      return 'siena';
    case 'Ferrara':
      return 'ferrara';
    case 'Trieste':
      return 'trieste';
    default:
      return '';
  }
};

const linkRedirect = ({ city, locale }: { city: string; locale: string }) => {
  const redirectCampusCity = getCityRedirectCode(city);
  return locale === 'it'
    ? `https://campus.dovevivo.com/${redirectCampusCity}/`
    : `https://campus.dovevivo.com/en/${redirectCampusCity}/`;
};

export const utilityCitiesRedirect = ({ city, locale }: { city: string; locale: string }) => {
  const isRedirectCity = CITIES_EXTERNAL.some(town => getCityFormattedName(town.name, locale as TLocale) === city);
  const redirectCities = linkRedirect({ city, locale });

  return { isRedirectCity, redirectCities };
};
